import { combineReducers } from "redux";
import { frameWorkReducer } from "./FrameworkReducer";
import { usersReducer } from "./UserReducer";
import { technologyReducer } from "./TechnologyReducer";
import { ideReducer } from "./IdeReducer";
import { versionControlReducer } from "./VersionControlReducer";
import { webServicesReducer } from "./WebServiceReducer";
import { otherSkillsReducer } from "./OtherSkillsReducer";
import { operatingSystemReducer } from "./OperatingSystemReducer";
import { googleComponentReducer } from "./GoogleComponentReducer";
import { appSettingReducer } from "./AppSettingReducer";
import { projectReducer } from "./ProjectReducer";
import { responsibilityReducer } from "./ResponsibilityReducer";
import { designationReducer } from "./DesignationReducer";
import { toolReducer } from "./ToolReducer";
import {vendorReducer } from "./VendorReducer";
import {userCountReducer} from "./DashboardReducer"
import { createdCVReducer } from "./CreatedCVReducer";

export const masterReducer = combineReducers({
  users: usersReducer,
  technology: technologyReducer,
  framework: frameWorkReducer,
  ide: ideReducer,
  vendor: vendorReducer,
  versionControl: versionControlReducer,
  webService: webServicesReducer,
  otherSkills: otherSkillsReducer,
  operatingSystem: operatingSystemReducer,
  googleComponent: googleComponentReducer,
  appSetting: appSettingReducer,
  project:projectReducer,
  responsibility:responsibilityReducer,
  designation:designationReducer,
  tool:toolReducer,
  dashboardCount:userCountReducer,
  createdCV:createdCVReducer,
});
